<template>
  <div class="home showall">
    <!-- landing  -->
    <div class="landing-main">
      <img :src="bgGray" alt="" class="abs-gray-bg" />
      <pageHeader />
      <landingComp :introSite="introSite" />
    </div>
    <specialsComp :advantages="advantages" />
    <orderSteps :orderStepsData="orderStepsData"/>
    <appSlider :appImages="appImages" :introSite="introSite"/>
    <statsView :introSite="introSite"/>
    <pageFooter />
  </div>
</template>

<script setup>
import pageHeader from "../components/pageHeader.vue";
import landingComp from "../components/home/landingComp";
import specialsComp from "../components/home/specialsComp";
import orderSteps from "../components/home/orderSteps";
import appSlider from "../components/home/appSlider";
import statsView from "../components/home/statsView";
import pageFooter from "../components/pageFooter";
import { onMounted, ref } from "vue";
import axios from "axios";

// reactive state
const bgGray = ref(
  require("../assets/imgs/natural-marble-pattern-background.png")
);
const advantages = ref([]);
const appImages = ref([]);
const introSite = ref([]);
const orderStepsData = ref([]);

// functions
function getSpecials() {
  axios.get("/advantages").then((response) => {
    advantages.value = response.data.data;
  });
}
function appImgs() {
  axios.get("/images").then((response) => {
    appImages.value = response.data.data;
  });
}
function getIntroSite() {
  axios.get("/intro-site").then((response) => {
    introSite.value = response.data.data;
  });
}
function getOrderSteps() {
  axios.get("/order-steps").then((response) => {
    orderStepsData.value = response.data.data;
  });
}

// mounted
onMounted(() => {
  getSpecials();
  appImgs();
  getIntroSite();
  getOrderSteps();
});
</script>
